import moment from "moment";
import dynamic from "next/dynamic";

import Link from "../../components/Link";

const HashtagLink = dynamic(() => import("../../components/HashtagLink"), {
  ssr: false,
});

export const Item = ({
  article_name: title,
  article_index: index,
  cover_image: imageUrl,
  date,
  tagslug,
}: ArticleResponse) => {
  return (
    <div className="card-major card-major-text tags-page__card">
      <div className="card-major__media desktop-hidden">
        <span
          className="card-major__media-pic"
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      </div>
      <div className="card-major__body">
        <div className="link link-arrow mobile-hidden">
          <i className="link__text">Прочесть</i>
          <span className="icon icon-arrow-btn link__icon" />
        </div>
        <Link className="card-major__title" to={`/${index}`}>
          {title}
        </Link>
        <div className="article-data card-major__data">
          <div className="article-data__item">
            <HashtagLink taguslug={tagslug} />
          </div>
          <div className="article-data__item">
            <time className="article-date">
              <span className="article-date__desktop">
                {moment(date).format("DD MMMM YYYY")}
              </span>
              <span className="article-date__mobile">
                {moment(date).format("DD.MM.YY")}
              </span>
            </time>
          </div>
        </div>
      </div>
    </div>
  );
};
